import React from 'react';
import styled from '@benzinga/themetron';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { DateTime } from 'luxon';
import CustomTooltip from './CustomTooltip';

export interface CoveyAnalystChartProps {
  data?: CoveyAnalystPerformance[];
}

export interface CoveyAnalystPerformance {
  date_time: string;
  's&p_500_total_return': number;
  top_analyst_total_return: number;
}

export const CoveyAnalystChart: React.FC<CoveyAnalystChartProps> = ({ data }) => {
  const performanceData =
    data && Array.isArray(data)
      ? data.map(performance => {
          const jsDate = new Date(performance.date_time);
          const date = DateTime.fromJSDate(jsDate).toFormat('MMM d, yyyy');

          return {
            'S&P 500 Return': performance['s&p_500_total_return'],
            'Top Analyst Return': performance.top_analyst_total_return,
            date,
          };
        })
      : [];

  return (
    <Container className="covey-analyst-chart w-full h-[500px]">
      <ResponsiveContainer height="100%" width="100%">
        <LineChart
          data={performanceData}
          height={400}
          margin={{
            bottom: 5,
            left: -20,
            right: 0,
            top: 5,
          }}
          width={600}
        >
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip
            content={<CustomTooltip />}
            formatter={(value: number) => {
              if (isNaN(value)) return null;
              return value.toFixed(2);
            }}
            wrapperClassName="covey-analyst-chart-tooltip"
          />
          <Legend
            verticalAlign="top"
            wrapperStyle={{
              paddingBottom: '1rem',
            }}
          />
          <Line activeDot={{ r: 8 }} dataKey="S&P 500 Return" stroke="#8884d8" type="monotone" />
          <Line dataKey="Top Analyst Return" stroke="#82ca9d" type="monotone" />
        </LineChart>
      </ResponsiveContainer>
    </Container>
  );
};

const Container = styled.div`
  &.covey-analyst-chart {
    .recharts-cartesian-axis-tick {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }
`;
